module.exports = __webpack_public_path__ + "static/media/mouthLowerDownRight.71c2a771.obj";